import { StaticArticlePostInput } from '../../templates/inputs/StaticArticlePostInput';
import { ArticlePage } from '../components/ArticlePage';
import { isArticlePost } from '../PostTypes';
import { ArticlePostData } from '../types/ArticlePostType';
import { defineTemplate } from './TemplateUtils';

export type StaticArticlePostData = Omit<ArticlePostData, 'pages'> & {
    pages: [ArticlePage];
};

export const isStaticArticlePost = (
    data: unknown,
): data is StaticArticlePostData => {
    return isArticlePost(data) && data.pages.length === 1;
};

export const StaticArticleMedium = defineTemplate(
    'Article',
    'Medium',
    StaticArticlePostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Medium',
            pages: [{}],
        }) satisfies StaticArticlePostData,
    isStaticArticlePost,
);
export const StaticArticleLarge = defineTemplate(
    'Article',
    'Large',
    StaticArticlePostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Large',
            pages: [{}],
        }) satisfies StaticArticlePostData,
    isStaticArticlePost,
);
